var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUpDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 9,
  fill: "none",
  viewBox: "0 -0.5 9 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6B7280",
  d: "M4.461 1.156a.35.35 0 0 0-.496 0L2.209 2.911a.351.351 0 0 0 .497.497l1.507-1.507L5.72 3.408a.351.351 0 0 0 .497-.497zM2.706 5.018a.351.351 0 0 0-.497.496L3.965 7.27c.137.137.36.137.496 0l1.756-1.756a.351.351 0 0 0-.497-.496L4.213 6.525z"
})));
export default SvgChevronUpDown;